import moment from 'moment';
import React, { useContext, useMemo } from 'react';
import LocalizationContext from '../../contexts/Localizations';
import './styles.scss';

interface EventDateProps {
  startDate: string;
  endDate?: string;
}

const EventDate = ({
  startDate,
  endDate,
}: EventDateProps) => {
  const { locale } = useContext(LocalizationContext);
  const startMoment = useMemo(() => moment(startDate).locale(locale), [startDate]);
  const endMoment = useMemo(() => endDate && moment(endDate).locale(locale), [endDate]);
  const format = 'DD MMMM YYYY';
  let startFormatted = startMoment.format(format);
  let endFormatted = '';

  if (endMoment && startMoment.format(format) !== endMoment.format(format)) {
    endFormatted = endMoment.format(format);

    if (startMoment.year() === endMoment.year()) {
      if (startMoment.month() !== endMoment.month()) {
        startFormatted = startMoment.format('DD MMMM');
      } else if (startMoment.date() !== endMoment.date()) {
        startFormatted = startMoment.format('DD');
      }
    }
  }

  return (
    <time className="event-date" dateTime={startMoment.toISOString()}>
      <span className="event-date__start">{startFormatted}</span>
      {endFormatted && <span className="event-date__end">{endFormatted}</span>}
    </time>
  );
};

export default EventDate;
